import AnchorAPIError from './AnchorAPIError';

const fetchSocialUrls = ({ stationId }) =>
  fetch(`/api/proxy/v3/userSocialUrl/station/webStationId:${stationId}`, {
    credentials: 'same-origin',
  }).then(response => {
    if (response.ok) {
      return response.json();
    }
    if (response.status === 400) {
      throw new AnchorAPIError(response, `Missing image`);
    }
    throw new AnchorAPIError(
      response,
      `Non 200 response status: ${response.status}`
    );
  });

export { fetchSocialUrls };
